<template>
  <div
      class="hs-null"
      :class="[styleType, styleType && styleType !== 'text' ? 'default' : '', isGrayBg ? 'gray-bg' : '', retryBtn ? 'retryBtn' : '']"
  >
    <template v-if="noData">
      <template v-if="styleType && styleType !== 'text'">
        <div class="logo" :style="logoStyle"></div>
        <div class="title">{{title}}</div>
        <div class="sub-title" v-if="subTitle">{{subTitle}}</div>
        <div v-if="retryBtn" :style="{height: styleType === 'noOrders' ? '58px' : 'calc(30dvh - 65px)'}"></div>
        <div class="retry" v-if="retryBtn" @click="$emit('delegate')">{{retryBtn}}</div>
      </template>
      <template v-else-if="styleType === 'text'">
        <div class="title">{{title}}</div>
        <div class="sub-title" v-if="subTitle">{{subTitle}}</div>
      </template>
      <template v-else>
        <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/null/null-image.png')})`}"></div>
        <p>{{title}}</p>
      </template>
    </template>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from 'vue'
/**
 * 当 styleType 有值 subtitle 才生效
 *
 * */
export default {
  props: {
    title: {
      type: String,
      default: Vue.prototype.$t('NoData')
    },
    styleType: {
      type: String,
      default: ''
    },
    isGrayBg: {
      type: Boolean,
      default: false
    },
    subTitle: {
      type: String,
      default: ''
    },
    retryBtn: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: ''
    },
  },
  computed: {
    noData() {
      return !Vue.prototype.$loading.isLoading()
    },
    logoStyle() {
      return this.logoName ? {
        backgroundImage: `url(${require(`@/assets/image/base/null/${this.logoName}`)})`
      } : {}
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-null
  @extend .flex-column
  @extend .flex-start
  width 100%
  height 100%
  font-size 16px
  &[type='font16']{
    margin-top: 40px;
    >.title{
      @extend .hs-font-subtitle-big;
    }
  }
  >.logo
    width 238px
    height 137px
    background-size 100% 100%
    margin-top 90px
  >p
    width 100%
    margin-top 20px
    padding 0 50px
    color $color_font_gray_1
    text-align center
    line-height 1.2em
  >.title
    @extend .hs-font-subtitle-middle
    padding: 0 50px;
    color $color_black_900
    text-align: center;
  >.sub-title
    @extend .hs-font-caption-1
    color $color_black_100
    padding: 0 50px;
    text-align: center;
    margin-top 8px
.default{
  @extend .flex-column
  @extend .flex-start
  width 100%
  height auto
  &.gray-bg{
    >.logo{
      margin-bottom 12px;
    }
  }
  &.noMessage{
    >.logo{
      background-image url('@/assets/image/base/null/no_message.png')
    }
  }
  &.noOrders{
    >.logo{
      background-image url('@/assets/image/base/null/no_orders.png')
    }
  }
  &.empty{
    >.logo{
      background-image url('@/assets/image/base/null/empty.png')
    }
  }
  &.failedLoad{
    >.logo{
      background-image url('@/assets/image/base/null/failed_load.png')
    }
  }
  &.noResultsFound{
    >.logo{
      background-image: url('@/assets/image/base/null/no_results_found.png')
    }
  }
  &.retryBtn{
    >.retry{
      @extend .flex-center
      @extend .pointer
      @extend .hs-font-subtitle-big;
      color $color_black_300
      height 46px
      width 247px
      border-radius 8px
      border 0.5px solid $color_black_100
      &:hover {
        opacity 0.8
      }
    }
  }
  >.logo{
    width 230px
    height 141px
    background-size 100% 100%
    margin-top: 0;
  }
  >.title{
    @extend .flex-center
    @extend .hs-font-subtitle-big;
    width 300px
  }
  >.sub-title{
    @extend .hs-font-caption-1;
    margin-top: 8px;
    color: $color_black_100;
  }
}

</style>
